
//require("./bootstrap");
//require("datatables.net");
//require("./delsites");
import {initializeInstallationsTable} from "./datatables/installationDataTables";
import {initializeStandardDataTables} from './datatables/standardDataTables';
import {initializeDelsitesTable} from './datatables/delsitesDataTables';
import {initializeBillingRowsTable} from './datatables/billingRowsDataTables';

import Alpine from "alpinejs";
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import invoiceWizard from './components/invoice-wizard';
import notificationTray from './components/notification-tray';
import tableLoader from './components/table-loader';
import invoicePage from './components/invoice-page';
import {initTooltips} from './components/tooltip';

import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";

const Swedish = require("flatpickr/dist/l10n/sv").default.sv;
flatpickr.localize(Swedish);

window.Alpine = Alpine;
Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.data('invoiceWizard', invoiceWizard);
Alpine.data('tableLoader', tableLoader);
Alpine.data('invoicePage', invoicePage);
initTooltips();
Alpine.store('tray', notificationTray(window.notificationTrayConfig ?? {}));
Alpine.start();

window.clearDataTablesStorage = function() {
    Object.keys(localStorage)
        .filter(key => key.startsWith('DataTables_'))
        .forEach(key => localStorage.removeItem(key));
};

if (typeof jQuery !== 'undefined') {
    $(function () {
        initializeStandardDataTables();
        initializeDelsitesTable();
        initializeBillingRowsTable();
        initializeInstallationsTable();
    });
}
